export default "__VITE_ASSET__BT0ToVr4__"